import { request } from '@/utils/request'

export function getTeacherSignatureTask(ticket) {
  return request({
    url: `/system/user/profile/teacher-signature/h5/${encodeURIComponent(ticket)}`,
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

export function submitTeacherSignature(ticket, data) {
  return request({
    url: `/system/user/profile/teacher-signature/h5/${encodeURIComponent(ticket)}/submit`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      isToken: false,
      repeatSubmit: false
    }
  })
}
